import { lazyPage } from '../lazy'
import type { VerticalManifest } from '../types'

export const staysManifest: VerticalManifest = {
  code: 'stays',
  brand: {
    name: 'Aure Guests',
    tagline: {
      es: 'La guía digital de tu alojamiento',
      pt: 'O guia digital da sua hospedagem',
      en: 'The digital guidebook for your rental',
    },
  },
  landing: lazyPage(() => import('./landing/LandingPage'), 'LandingPage'),
  guestOverrides: { es: {}, pt: {}, en: {} },
}
